var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeaderboardActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.93333 5.68333L2.93333 8.33323L2.93333 8.33333M2.93333 5.68333L4.56667 10.1638C4.11704 10.1389 3.69091 9.94923 3.37084 9.62916C3.02713 9.28545 2.83382 8.81941 2.83333 8.33333H2.93333M2.93333 5.68333H4.56667V10.0637M2.93333 5.68333L4.56667 10.0637M2.93333 8.33333C2.93382 8.79289 3.11659 9.23349 3.44155 9.55845C3.74286 9.85976 4.14359 10.0388 4.56667 10.0637M2.93333 8.33333L4.56667 10.0637M21.1668 3.65H21.1667H19.4333L19.4333 2.83333L19.4333 2.83323C19.4328 2.32067 19.229 1.82924 18.8665 1.4668C18.5041 1.10436 18.0127 0.900512 17.5001 0.9H17.5L6.5 0.9L6.4999 0.9C5.98733 0.900512 5.4959 1.10436 5.13346 1.4668C4.77102 1.82924 4.56718 2.32067 4.56667 2.83323V2.83333V3.65L2.83333 3.65L2.83323 3.65C2.32067 3.65051 1.82924 3.85436 1.4668 4.2168C1.10436 4.57924 0.900512 5.07067 0.9 5.58323V5.58333L0.9 8.33333L0.9 8.33346C0.901246 9.33202 1.29848 10.2893 2.00457 10.9954C2.71066 11.7015 3.66798 12.0988 4.66654 12.1H4.66667H4.88582C5.27997 13.4923 6.06423 14.7435 7.14673 15.7054C8.22679 16.6652 9.55794 17.2962 10.9833 17.5252V21.0667H6.5H6.4V21.1667V23V23.1H6.5H17.5H17.6V23V21.1667V21.0667H17.5H13.0167V17.5246C14.4608 17.3285 15.8157 16.7104 16.9108 15.7467C18.0085 14.7807 18.7952 13.5116 19.1722 12.1H19.3333H19.3335C20.332 12.0988 21.2893 11.7015 21.9954 10.9954C22.7015 10.2893 23.0988 9.33202 23.1 8.33346V8.33333V5.58333V5.58323C23.0995 5.07067 22.8956 4.57924 22.5332 4.2168C22.1708 3.85436 21.6793 3.65051 21.1668 3.65ZM6.59999 9.89973H6.6V9.89808V2.93333H17.4V10.1667C17.4 10.8899 17.2547 11.6057 16.9728 12.2717C16.6908 12.9377 16.278 13.5403 15.7587 14.0437C15.2394 14.5471 14.6243 14.9411 13.9499 15.2022C13.276 15.4632 12.5565 15.5862 11.8342 15.564C10.4009 15.4744 9.05725 14.836 8.08246 13.7814C7.10732 12.7264 6.57636 11.3362 6.59999 9.89973ZM21.0667 8.33323C21.0662 8.79283 20.8834 9.23347 20.5584 9.55845C20.2571 9.85976 19.8564 10.0388 19.4333 10.0637V5.68333H21.0667V8.33323Z",
    fill: "url(#paint0_linear_1283_27500)",
    stroke: "url(#paint1_linear_1283_27500)",
    strokeWidth: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1283_27500",
    x1: 1.66,
    y1: 2.02667,
    x2: 21.3867,
    y2: 21.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9E8A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335083,
    stopColor: "#E6745A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678481,
    stopColor: "#A6708E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8490A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1283_27500",
    x1: 1.66,
    y1: 2.02667,
    x2: 21.3867,
    y2: 21.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9E8A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335083,
    stopColor: "#E6745A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678481,
    stopColor: "#A6708E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8490A8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboardActive);
export default __webpack_public_path__ + "static/media/leaderboardActive.b31fea31a7348992d5f9aee78fe29759.svg";
export { ForwardRef as ReactComponent };